<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card>
            <div slot="header">{{ titulo }}</div>

            <template v-if="semestral">
              <b-form-group
                label="Período"
                label-for="periodo"
                :label-cols="labelCols"
                horizontal>
                <b-form-select 
                  v-model="indicadorSemestreNombre" 
                  :options="semestres" 
                  :state="periodoValido"
                  class="mb-3 select-fecha select-fecha-mes"
                  @blur.native="validate">
                  <template slot="first">
                    <option :value="null">Seleccione un semestre</option>
                  </template>
                </b-form-select>
  
                <b-form-select 
                  v-model="indicadorAnio" 
                  :options="anios" 
                  :state="periodoValido"
                  class="mb-3 select-fecha select-fecha-anio"
                  @blur.native="validate">
                  <template slot="first">
                    <option :value="null">Seleccione un año</option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="indicadorAnioFeedback">
                  {{ periodoInvalidoMsj }}
                </b-form-invalid-feedback>
              </b-form-group>
            </template>

            <template v-if="!semestral">
              <b-form-group
                label="Período"
                label-for="periodo"
                :label-cols="labelCols"
                horizontal>
                <b-form-select 
                  v-model="indicadorAnio" 
                  :options="anios" 
                  :state="periodoValido"
                  class="mb-3"
                  @blur.native="validate">
                  <template slot="first">
                    <option :value="null">Seleccione un año</option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="indicadorAnioFeedback">
                  {{ periodoInvalidoMsj }}
                </b-form-invalid-feedback>
              </b-form-group>              
            </template>

            <b-form-group
              label="Fecha Vigencia - Desde"
              label-for="fechaVigenciaDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaVigenciaDesde" 
                v-model="fechaVigenciaDesde" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Vigencia - Hasta"
              label-for="fechaVigenciaHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaVigenciaHasta"
                v-model="fechaVigenciaHasta" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Pje.Objetivo"
              label-for="pjeObjetivo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="pjeObjetivo"
                v-model.trim="$v.pjeObjetivo.$model" 
                :state="pjeObjetivoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="pjeObjetivoFeedback">
                {{ pjeObjetivoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Descripcion"
              label-for="descripcion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="descripcion"
                v-model.trim="$v.descripcion.$model" 
                :state="descripcionValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="descripcionFeedback">
                {{ descripcionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-row>
      <b-col xl="12">
        <b-card header="Historial del Indicador - Total">
          <app-historico
            ref="historicoTotal"
            :semestral="semestral"
            :totalNegocio="true"
            :showTitulo="false">
          </app-historico>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col xl="12">
        <b-card header="Historial del Indicador - Sin Reembolsos">
          <app-historico
            ref="historico"
            :semestral="semestral"
            :totalNegocio="false"
            :showTitulo="false">
          </app-historico>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Historico from '../dashboard/historicos/IndicadoresHistoricoRentabilidadBruta.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { decimal, maxLength, minValue } from 'vuelidate/lib/validators';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'indicadorRentabilidadBruta/getField',
  mutationType: 'indicadorRentabilidadBruta/updateField',
});

export default {
  name: 'IndicadorRentabilidadABM',
  components: {
    appHistorico: Historico,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    semestral: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      noValidar: true,
      periodoValido: null,
      periodoInvalidoMsj: '',
      pjeObjetivoValido: null,
      pjeObjetivoInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',

      semestres: [],
      anios: [],

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'fechaVigenciaDesde',
      'fechaVigenciaHasta',
      'indicadorSemestre',
      'indicadorSemestreNombre',
      'indicadorAnio',
      'pjeObjetivo',
      'descripcion'    
    ]),
    titulo() {
      if ((/true/i).test(this.semestral)) {
        return 'Indicador de Rentabilidad - Semestral';
      }

      return 'Indicador de Rentabilidad - Anual';
    }    
  },
  created() {
    let indicadorId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        indicadorId = this.$route.params.id;
      }
    }

    this.semestres = ['1er Semestre', '2do Semestre'];
    this.anios = this.getAniosPeriodo();

    let params = {
      semestral: this.semestral,
      indicadorId
    }

    this.showSpinner();
    this.$store.dispatch('indicadorRentabilidadBruta/inicializar', params)
      .then(() => {
        this.$refs.historico.getIndicadores();
        this.$refs.historicoTotal.getIndicadores();
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());    
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'pjeObjetivo' || validarTodos) {
        if (this.$v.pjeObjetivo.$error) {
          this.pjeObjetivoValido = false;
          if (!this.$v.pjeObjetivo.decimal) {
            this.pjeObjetivoInvalidoMsj = 'El porcentaje debe ser un valor numérico';
          } else {
            if (!this.$v.pjeObjetivo.minValue) {
              this.pjeObjetivoInvalidoMsj = 'El porcentaje ingresado no es válido';
            }      
          }     
        } else {
          this.pjeObjetivoValido = null;
          this.pjeObjetivoInvalidoMsj = '';
        }
      }

      if (campo == "descripcion" || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          if (!this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripcion sólo pueden contener hasta 50 caracteres';
          }
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      if ((/true/i).test(this.semestral)) {
        if (this.indicadorSemestreNombre == null || this.indicadorAnio == null) {
          this.periodoValido = false;
          this.periodoInvalidoMsj = 'Debe seleccionar el período correspondiente';
          save = false;
        }
      } else {
        if (this.indicadorAnio == null) {
          this.periodoValido = false;
          this.periodoInvalidoMsj = 'Debe seleccionar el período correspondiente';
          save = false;
        }
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('indicadorRentabilidadBruta/save')
            .then( () => this.showModalMsj ('La información del indicador se actualizó con éxito.', this.goList, this.goList, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      if ((/true/i).test(this.semestral)) {
        this.$router.push({ name: 'IndicadoresRentabilidadSemestral' });
      } else {
        this.$router.push({ name: 'IndicadoresRentabilidadAnual' });
      }
    },
  },
  validations: {
    pjeObjetivo: { 
      decimal, 
      minValue: minValue(0) },
    descripcion: {
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
  #descripcion {
    text-transform: none;
  }
</style>
